import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const FarmReport = lazy(() => import('../../pages/report/farm_report/FarmReport'));
const CropPlaningReport = lazy(() => import('../../pages/report/crop_planing_report/CropPlaningReport'));
const ConstructionReport = lazy(() => import('../../pages/report/construction_report/ConstructionReport'));

export const ReportImport = {
    RoutesMap,
    FarmReport,
    CropPlaningReport,
    ConstructionReport,
}